import ReactQuill, { ReactQuillProps } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from '@emotion/styled';

type EditorProps = Pick<
  ReactQuillProps,
  'value' | 'onChange' | 'className' | 'placeholder' | 'defaultValue' | 'onBlur'
> & {
  showToolbar?: boolean;
  borderless?: boolean;
};

const StyledQuill = styled(ReactQuill)<EditorProps>`
  font-family: 'Poppins';
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;

  .ql-container {
    border: none;
    height: 100%;
    width: 100%;
    overflow: hidden;

    .ql-editor {
      font-family: 'Poppins';
      padding-bottom: 1.25rem;
    }
  }

  ${({ borderless }) =>
    borderless
      ? `
          .ql-container {
            border: none;
          }
          .ql-toolbar {
            border: none;
            border-bottom: 1px solid #e0e0e0;
          }
        `
      : ''}
`;

const Editor = ({
  showToolbar,
  placeholder,
  borderless = true,
  ...rest
}: EditorProps) => {
  const toolbarOptions = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline'],
    [{ color: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
  ];

  const module = {
    toolbar: showToolbar ? toolbarOptions : false,
  };

  return (
    <StyledQuill
      borderless={borderless}
      modules={module}
      {...rest}
      placeholder={placeholder || 'The generated notes will appear here...'}
    />
  );
};

export default Editor;
